import React, { useEffect, useState } from 'react';
import { Button, IconButton, Input, SelectPicker, Tooltip, Whisper } from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';
import { CustomInput } from './costing-page';
import { cbmFunction } from './functions';
import { useLocation } from 'react-router-dom';
import globalIP from '@/GlobelIP';
import axios from 'axios';
export type SubColumns = {
  label: string;
  key: string;
  renderCell: (_: any, index: number) => JSX.Element | number;
};
export type Columns = {
  [x: string]: any;
  label: string;
  key: string;
  fixed?: boolean;
  subColumns?: SubColumns[];

  renderCell?: (_: any, index: number) => JSX.Element | number;
};
export const unitData = [
  { label: 'Cm', value: 'Cm' },
  { label: 'Inch', value: 'Inch' }
];
export const PCSData = [
  { label: 'Sq ft', value: 'sqft' },
  // { label: 'cu ft', value: 'cuft' },
  { label: 'CFT', value: 'cft' },
  { label: 'CBM', value: 'cbm' },
  { label: 'KG', value: 'kg' },
  { label: 'Pcs', value: 'Pcs' },
  { label: 'Inch', value: 'Inch' }
];
const unittype = [
  { label: 'Sq ft', value: 'sqft' },
  // { label: 'cu ft', value: 'cuft' },
  { label: 'CFT', value: 'cft' },
  { label: 'CBM', value: 'cbm' },
  { label: 'KG', value: 'kg' },
  { label: 'Pcs', value: 'pcs' },
  { label: 'Inch', value: 'inch' }
];

const uomMapping = {
  wmaterial: [
    'sqft',
    'cft'
    // 'inch'
  ],
  mrmaterial: [
    'sqft',
    'cft',
    'cbm'
    // 'inch'
  ],
  cmaterial: ['kg', 'pcs', 'inch']
};
const marbelUnitData = unittype.filter(item => {
  return uomMapping.mrmaterial.includes(item.value.toLowerCase());
});
const woodUnitData = unittype.filter(item =>
  uomMapping.wmaterial.includes(item.value.toLowerCase())
);
// console.log('marbelUnitData', marbelUnitData);
export const unitData2 = [
  { label: 'Pcs', value: 'pcs' },
  { label: 'Kg', value: 'kg' }
];
export default function useColumns(
  handleChange,
  costingTableData,
  handleDeleteRow,
  state,
  setFieldData,
  setReload,
  productData,
  fieldData,
  setlatest,
  latest,
  changeCount,
  setChangeCount
) {
  const UpdateCBM = (index, CBM) => {
    if (CBM) {
      if (costingTableData.CostingWood[index]) {
        if (costingTableData.CostingWood[index].PCS) {
          costingTableData.CostingWood[index].CFT = CBM;
        }
      }
    } else {
      costingTableData.CostingWood[index].CFT = 0;
      costingTableData.CostingWood[index].woodamount = 0;
    }
    if (costingTableData.CostingWood[index]?.CFT && costingTableData.CostingWood[index]?.woodrate) {
      const result =
        Number(costingTableData.CostingWood[index]?.CFT) *
        Number(costingTableData.CostingWood[index]?.woodrate);
      if (costingTableData.CostingWood[index]) {
        if (costingTableData.CostingWood[index]?.woodrate) {
          costingTableData.CostingWood[index].woodamount = +result.toFixed(2);
        }
      }
    } else {
      costingTableData.CostingWood[index].woodamount = 0;
    }
    setChangeCount(prev => prev + 1);
    // setReload(prev => !prev);
  };
  const [categorydata, setCategorydata] = useState([]);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/mst-components?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mst-components?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CompName,
          value: item.attributes.CompName
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [materialData, setMaterialData] = useState([]);

  useEffect(() => {
    const fetchAllMaterialData = async () => {
      try {
        let allMaterials = [];

        // Fetch the first page to get pagination info
        const firstResponse = await axios.get(`${globalIP}/api/mstmaterials?&pagination[page]=1`);
        const firstPageData = firstResponse.data.data;
        const pageCount = firstResponse.data.meta.pagination.pageCount;

        allMaterials = [...firstPageData];

        // Fetch remaining pages if more than 1 page
        const pageRequests = [];

        for (let page = 2; page <= pageCount; page++) {
          pageRequests.push(axios.get(`${globalIP}/api/mstmaterials?&pagination[page]=${page}`));
        }

        const responses = await Promise.all(pageRequests);
        responses.forEach(res => {
          allMaterials = [...allMaterials, ...res.data.data];
        });

        setMaterialData(allMaterials);
      } catch (error) {
        console.error('Error fetching all material data:', error);
      }
    };

    fetchAllMaterialData();
  }, []);
  useEffect(() => {
    if (productData?.ProductionDetail?.length && materialData) {
      const updatedCostingMaterial = productData.ProductionDetail.filter(detail =>
        state?.Material?.some(item => item.Type === 'cmaterial' && item.value === detail.MaterialNm)
      ).map(detail => {
        const matchedMaterial = materialData.find(
          mat =>
            mat.attributes.MaterialName === detail.MaterialNm && mat.attributes.Type === 'cmaterial'
        );
        return {
          chiefmaterial: detail.MaterialNm, // Set the MaterialNm from ProductionDetail
          remark: detail.Remark,
          unit: matchedMaterial?.attributes?.uom || 'kg', // Default or derive from detail if available
          wgtqty:
            matchedMaterial?.attributes?.uom == 'kg' || matchedMaterial?.attributes?.uom == ''
              ? detail.MatNetWeight
              : detail.Qty || detail.MatNetWeight,
          materialrate: matchedMaterial?.attributes?.Cost || 0, // Match and get cost
          batta: matchedMaterial?.attributes?.batta || 0, // Default batta
          totalmaterialcost: detail.MatNetWeight * (matchedMaterial?.attributes?.Cost || 0) || 0 // Calculate total cost
        };
      });
      handleChange('CostingMaterial', updatedCostingMaterial, 'init');

      if (updatedCostingMaterial.length > 0) {
        handleChange('CostingMaterial', updatedCostingMaterial[0]?.wgtqty, 'wgtqty', 0);
        setFieldData(prev => ({
          ...prev,
          Netwgt: 0
        }));
        setReload(prev => !prev);
      }
      setReload(prev => !prev);
    }
  }, [productData?.ProductionDetail, state?.Material, materialData]);

  const columns: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Chief Material',
      key: 'chiefMaterial',
      fixed: false,
      renderCell: (_, index) => {
        const chiefMaterialData = state?.Material?.filter(item => item.Type === 'cmaterial');
        // console.log('chiefMaterialData',chiefMaterialData);
        return (
          <SelectPicker
            data={chiefMaterialData}
            searchable={false}
            cleanable={false}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingMaterial[index]?.chiefmaterial}
            onChange={value => {
              // Update the chiefmaterial field
              handleChange('CostingMaterial', value, 'chiefmaterial', index);
              const matchedMaterial = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'cmaterial'
              );
              // Update the materialrate and totalmaterialcost dynamically
              handleChange(
                'CostingMaterial',
                matchedMaterial?.attributes?.Cost || 0,
                'materialrate',
                index
              );
              const weightQty = costingTableData.CostingMaterial[index]?.wgtqty || 0;
              handleChange(
                'CostingMaterial',
                weightQty * (matchedMaterial?.attributes?.Cost || 0),
                'totalmaterialcost',
                index
              );
              handleChange(
                'CostingMaterial',
                matchedMaterial?.attributes?.uom || 'kg',
                'unit',
                index
              );
              handleChange(
                'CostingMaterial',
                matchedMaterial?.attributes?.batta || 0,
                'batta',
                index
              );
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Remark',
      key: 'remark',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <Input
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingMaterial[index]?.remark}
            disabled={!productData.isEdit}
            onChange={(value) =>
              handleChange('CostingMaterial', value, 'remark', index)
            }
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'unit',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={unitData2}
            size="xs"
            disabled={!productData.isEdit}
            cleanable={false}
            searchable={false}
            style={{ width: '100%' }}
            value={costingTableData.CostingMaterial[index]?.unit}
            onChange={value => handleChange('CostingMaterial', value, 'unit', index)}
          />
        );
      }
    },
    {
      label: 'Weight/Qty',
      key: 'weightQty',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.wgtqty || 0}
            onChange={value => {
              // 1. Update wgtqty
              handleChange('CostingMaterial', value, 'wgtqty', index);

              // 2. Calculate total wgtqty
              const updatedMaterials = [...costingTableData.CostingMaterial];
              updatedMaterials[index].wgtqty = Number(value);
              const totalWgtQty = updatedMaterials.reduce((sum, item) => sum + (item.wgtqty || 0), 0);

              // 3. Update CostingProcess sizes and amounts based on type
              const updatedProcesses = costingTableData.CostingProcess.map((process) => {
                if (process.ProcessTyp === 'kg' || process.ProcessTyp === 'Pcs') {
                  const newSize = totalWgtQty;
                  const newAmt = newSize * process.prcsrate;
                  return {
                    ...process,
                    size: newSize,
                    prcsamt: newAmt
                  };
                }
                return process;
              });

              // 4. Apply updates
              handleChange('CostingProcess', updatedProcesses, 'init');

              // 5. Reset and refresh
              setFieldData(prev => ({
                ...prev,
                Netwgt: 0
              }));
              setReload(prev => !prev);
            }}
          />
        );
      }
    },

    {
      label: 'Material Rate',
      key: 'materialRate',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.materialrate || 0}
            onChange={value => {
              handleChange('CostingMaterial', value, 'materialrate', index);
              setFieldData(prev => ({
                ...prev,
                perkgrate: 0
              }));
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Batta',
      key: 'Batta',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.batta || 0}
            onChange={value => {
              handleChange('CostingMaterial', value, 'batta', index);
              setFieldData(prev => ({
                ...prev,
                perKgRate: 0
              }));
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Total',
      key: 'total',
      fixed: false,
      renderCell: (rowData, index) => {
        let calculate = 0;
        if (rowData?.materialrate || rowData?.batta || rowData?.wgtqty) {
          calculate =
            (Number(rowData?.materialrate) + Number(rowData?.batta)) * Number(rowData?.wgtqty);
          if (costingTableData.CostingMaterial[index]) {
            costingTableData.CostingMaterial[index].totalmaterialcost = calculate;
          }
        }

        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.totalmaterialcost.toFixed(2)}
            readOnly
            onChange={value => {
              handleChange('CostingMaterial', value, 'totalmaterialcost', index);
            }}
          />
        );
      }
    },
    {
      label: 'Add Material',
      key: 'addMaterial',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                color="red"
                appearance="primary"
                disabled={!productData.isEdit}
                onClick={() => handleDeleteRow('CostingMaterial', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];
  const convertUnit = (value, fromUnit, toUnit) => {
    if (!value || isNaN(value)) return 0;

    const inchToCm = 2.54;
    if (fromUnit == 'Inch' && toUnit == 'Cm') {
      return (Number(value) * inchToCm).toFixed(2);
    } else if (fromUnit == 'Cm' && toUnit == 'Inch') {
      return (Number(value) / inchToCm).toFixed(2);
    }
    return Number(value).toFixed(2); // No conversion needed if units are the same
  };

  useEffect(() => {
    if (productData?.ProductionDetail?.length && materialData) {
      // Filter and map only relevant wood materials
      const updatedCostingWood = productData.ProductionDetail.filter(detail =>
        state?.Material?.some(
          item =>
            (item.Type === 'wmaterial' || item.Type === 'mrmaterial') &&
            item.value === detail.MaterialNm
        )
      ).map(detail => {
        // Find the matching material and its rate
        const matchedMaterial = materialData.find(
          mat =>
            mat.attributes.MaterialName === detail.MaterialNm &&
            (mat.attributes.Type === 'wmaterial' || mat.attributes.Type === 'mrmaterial')
        );
        console.log('productData?.ProductionDetail?', productData?.ProductionDetail);
        // console.log('matchedMaterial?.attributes?.uom', matchedMaterial?.attributes?.uom);

        return {
          woodmaterial: detail.MaterialNm, // Set the MaterialNm from ProductionDetail
          Unit: matchedMaterial?.attributes?.uom, // Set the MaterialNm from ProductionDetail
          component: detail.Component || '', // Default value or fetch from detail
          remark: detail.Remark || '', // Default value or fetch from detail
          quantity: detail.MatNetWeight || 0, // Default weight/quantity
          F_L: detail.Length, // Default unit
          F_W: detail.Width, // Default unit
          F_T: detail.Height, // Default unit
          PCS: detail.Qty, // Default unit
          F_Unit: detail.Unit == 'cm' ? 'Cm' : 'Inch', // Default unit
          R_Unit: detail.Unit == 'cm' ? 'Cm' : 'Inch',
          woodrate: matchedMaterial?.attributes?.Cost || 0 // Match and get cost
        };
      });

      // Initialize CostingWood data
      handleChange('CostingWood', updatedCostingWood, 'init');
      setReload(prev => !prev);
    }
  }, [productData?.ProductionDetail, state?.Material, materialData]);

  const cbmFunctionMain = (L, W, T, U, pc, index) => {
    // console.log('L', L);
    // console.log('W', W);
    // console.log('T', T);
    // console.log('U', U);
    // console.log('pc', pc);
    let CFT;
    if (L && W && T && U == 'Cm' && pc) {
      CFT =
        parseFloat(L) *
        0.0328084 *
        (parseFloat(W) * 0.0328084) *
        (parseFloat(T) * 0.0328084) *
        Number(pc);
      return CFT.toFixed(4);
    } else if (L && W && T && U == 'Inch' && pc) {
      CFT = ((parseFloat(L) * parseFloat(W) * parseFloat(T)) / 1728) * Number(pc);
      return CFT.toFixed(4);
    } else if (L && W && T && U == 'Mm' && pc) {
      CFT =
        parseFloat(L) *
        0.00328084 *
        (parseFloat(W) * 0.00328084) *
        (parseFloat(T) * 0.00328084) *
        Number(pc);
      return CFT.toFixed(4);
    } else {
      return null;
    }
  };
  const handleCustomInputChangeMain = (rowData, index) => {
    const matchedMaterial = materialData.find(
      mat => mat.attributes.MaterialName === rowData?.woodmaterial
    )?.attributes.Type;
    console.log('matchedMaterialtype', matchedMaterial);
    handleChange('CostingWood', matchedMaterial, 'Type', index);
    // console.log('matchedMaterial?.attributes?.uom', matchedMaterial?.attributes?.uom);
    console.log('rowData?.Unit', rowData?.Unit);
    // console.log('matchedMaterial', matchedMaterial);
    if (rowData?.Unit == 'cft') {
      // handleCustomUpdateCFT(rowData, index)
      const finalUnit = rowData?.F_Unit;
      const rawUnit = rowData?.R_Unit;
      let convertedR_L = rowData?.F_L;
      let convertedR_W = rowData?.F_W;
      let convertedR_T = rowData?.F_T;

      if (matchedMaterial !== 'mrmaterial') {
        convertedR_L = convertUnit(convertedR_L, finalUnit, rawUnit);
        convertedR_L = Math.ceil((parseFloat(convertedR_L) + 4) / 6) * 6;

        convertedR_W = convertUnit(convertedR_W, finalUnit, rawUnit);
        convertedR_W = Number(convertedR_W) + (Number(convertedR_W) * 25) / 100;

        convertedR_T = convertUnit(convertedR_T, finalUnit, rawUnit);
        const decimalPart = parseFloat('.' + convertedR_T.toString().split('.')[1]);
        convertedR_T =
          decimalPart < 0.5 ? Math.floor(convertedR_T) + 0.5 : Math.floor(convertedR_T) + 1;
      }

      handleChange('CostingWood', convertedR_L, 'R_L', index);
      handleChange('CostingWood', convertedR_W, 'R_W', index);
      handleChange('CostingWood', convertedR_T, 'R_T', index);

      const CBM = cbmFunctionMain(
        convertedR_L,
        convertedR_W,
        convertedR_T,
        rawUnit,
        rowData?.PCS,
        index
      );
      UpdateCBM(index, CBM);
    } else if (rowData?.Unit == 'sqft') {
      let l = rowData?.F_L;
      let w = rowData?.F_W;
      let t = rowData?.F_T;
      let R_Unit = rowData?.R_Unit;
      console.log('R_Unit', R_Unit);
      handleChange('CostingWood', l, 'R_L', index);
      handleChange('CostingWood', w, 'R_W', index);
      handleChange('CostingWood', t, 'R_T', index);
      let area = 0;
      if (R_Unit === 'feet') {
        area = l * w;
      } else if (R_Unit === 'Inch') {
        area = (l * w) / 144;
      } else if (R_Unit === 'mm') {
        area = l * 0.00328084 * (w * 0.00328084);
      } else if (R_Unit === 'Cm' || R_Unit === 'cm') {
        area = l * w * 0.00107639;
      } else if (R_Unit === 'sq_feet') {
        area = (l * w) / 144;
      }
      const PCS = rowData?.PCS || 1;

      const CFT = area * PCS;
      const woodamount = CFT * rowData?.woodrate;
      handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
      handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    } else if (rowData?.Unit == 'cbm') {
      let l = rowData?.F_L;
      let w = rowData?.F_W;
      let t = rowData?.F_T;
      let r_unit = rowData?.R_Unit;
      let PCS = rowData?.PCS;
      handleChange('CostingWood', l, 'R_L', index);
      handleChange('CostingWood', w, 'R_W', index);
      handleChange('CostingWood', t, 'R_T', index);
      let area = 0;
      if (r_unit == 'Inch') {
        area = (l * t * w) / 61023;
      } else if (r_unit == 'Cm') {
        area = (l * t * w) / 1000000;
      } else if (r_unit == 'mm') {
        area = (l * t * w) / 1000000000;
      }
      const CFT = area * PCS;
      const woodamount = CFT * rowData?.woodrate;
      handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
      handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
      setChangeCount(prev => prev + 1);
    }
    setChangeCount(prev => prev + 1);
  };
  const handleCustomUpdateCFT = (rowData, index) => {
    const finalUnit = rowData?.F_Unit;
    const rawUnit = rowData?.R_Unit;
    let convertedR_L = rowData?.R_L;
    let convertedR_W = rowData?.R_W;
    let convertedR_T = rowData?.R_T;
    if (rowData.Type == 'wmaterial' && rowData.Unit == 'cft') {
      convertedR_L = rowData?.F_L;
      convertedR_W = rowData?.F_W;
      convertedR_T = rowData?.F_T;
      convertedR_L = convertUnit(convertedR_L, finalUnit, rawUnit);
      convertedR_L = Math.ceil((parseFloat(convertedR_L) + 4) / 6) * 6;

      convertedR_W = convertUnit(convertedR_W, finalUnit, rawUnit);
      convertedR_W = Number(convertedR_W) + (Number(convertedR_W) * 25) / 100;

      convertedR_T = convertUnit(convertedR_T, finalUnit, rawUnit);
      const decimalPart = parseFloat('.' + convertedR_T.toString().split('.')[1]);
      convertedR_T =
        decimalPart < 0.5 ? Math.floor(convertedR_T) + 0.5 : Math.floor(convertedR_T) + 1;
    }
    let area = 0;
    if (rawUnit === 'feet') {
      area = (convertedR_L * convertedR_W * convertedR_T) / 144;
    } else if (rawUnit === 'Inch') {
      area = (convertedR_L * convertedR_W * convertedR_T) / 1728;
    } else if (rawUnit === 'mm') {
      area = convertedR_L * 0.00328084 * (convertedR_W * 0.00328084) * (convertedR_T * 0.00328084);
    } else if (rawUnit === 'Cm' || rawUnit === 'cm') {
      area =
        (convertedR_L * 0.0328084 * (convertedR_W * 0.393701) * (convertedR_T * 0.393701)) / 144;
    } else if (rawUnit === 'sq_feet') {
      area = (convertedR_L * convertedR_W) / 144;
    }

    handleChange('CostingWood', convertedR_L, 'R_L', index);
    handleChange('CostingWood', convertedR_W, 'R_W', index);
    handleChange('CostingWood', convertedR_T, 'R_T', index);
    const PCS = rowData?.PCS || 1;
    const CFT = area * PCS;
    const woodamount = CFT * rowData?.woodrate;
    handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
    handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
  };
  const handleCustomUpdateCBM = (rowData, index) => {
    let l = rowData?.R_L;
    let w = rowData?.R_W;
    let t = rowData?.R_T;
    let r_unit = rowData?.R_Unit;
    let PCS = rowData?.PCS;
    handleChange('CostingWood', l, 'R_L', index);
    handleChange('CostingWood', w, 'R_W', index);
    handleChange('CostingWood', t, 'R_T', index);
    let area = 0;
    if (r_unit == 'Inch') {
      area = (l * t * w) / 61023;
    } else if (r_unit == 'Cm') {
      area = (l * t * w) / 1000000;
    } else if (r_unit == 'mm') {
      area = (l * t * w) / 1000000000;
    }
    const CFT = area * PCS;
    const woodamount = CFT * rowData?.woodrate;
    handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
    handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    setChangeCount(prev => prev + 1);
  };
  const handleCustomUpdateSQFT = (rowData, index) => {
    let l = rowData?.R_L;
    let w = rowData?.R_W;
    let t = rowData?.R_T;
    let R_Unit = rowData?.R_Unit;
    console.log('R_Unit', R_Unit);
    handleChange('CostingWood', l, 'R_L', index);
    handleChange('CostingWood', w, 'R_W', index);
    handleChange('CostingWood', t, 'R_T', index);
    let area = 0;
    if (R_Unit === 'feet') {
      area = l * w;
    } else if (R_Unit === 'Inch') {
      area = (l * w) / 144;
    } else if (R_Unit === 'mm') {
      area = l * 0.00328084 * (w * 0.00328084);
    } else if (R_Unit === 'Cm' || R_Unit === 'cm') {
      area = l * w * 0.00107639;
    } else if (R_Unit === 'sq_feet') {
      area = (l * w) / 144;
    }
    const PCS = rowData?.PCS || 1;

    const CFT = area * PCS;
    const woodamount = CFT * rowData?.woodrate;
    handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
    handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    setChangeCount(prev => prev + 1);
  };

  // useEffect(() => {
  //   if (!fieldData.updatedAt || latest) {
  //     costingTableData.CostingWood.forEach((item, index) => {
  //       // console.log('main ran');
  //       handleCustomInputChangeMain(item, index);
  //     });
  //     setlatest(false);
  //     // console.log('hi')
  //   }
  // }, [costingTableData.CostingWood, latest]);

  useEffect(() => {
    if (costingTableData.CostingProcess.length > 0 && costingTableData.CostingWood.length > 0) {
      // if (prevwooddata !== costingTableData.CostingWood) {

      setPrevwooddata(costingTableData.CostingWood);
      costingTableData.CostingProcess.forEach((process, index) => {
        const value = process.ProcessTyp;
        if (value === 'Inch') {
          if (costingTableData.CostingProcess[index]) {
            const sizeValue = highestValue.toFixed(2);
            handleChange('CostingProcess', sizeValue, 'size', index);
            const result = sizeValue * +costingTableData.CostingProcess[index].prcsrate;
            costingTableData.CostingProcess[index].prcsamt = result;
            handleChange('CostingProcess', result, 'prcsamt', index);
          }
        } else if (value === 'Pcs') {
          let qty = 0;
          costingTableData.CostingWood.forEach(wood => {
            if (wood.woodmaterial == costingTableData.CostingProcess[index].Processon) {
              qty = qty + Number(wood.PCS);
            }
          });
          handleChange('CostingProcess', qty, 'size', index);
          const result = qty * costingTableData.CostingProcess[index].prcsrate;
          handleChange('CostingProcess', result, 'prcsamt', index);
        } else if (value === 'sqft') {
          let qty = 0;
          costingTableData.CostingWood.forEach(wood => {
            if (
              wood.woodmaterial == costingTableData.CostingProcess[index].Processon &&
              wood.Unit == value
            ) {
              qty = qty + Number(wood.CFT);
            }
          });
          handleChange('CostingProcess', qty, 'size', index);
          const result = qty * costingTableData.CostingProcess[index].prcsrate;
          handleChange('CostingProcess', result, 'prcsamt', index);
        } else if (value === 'cft') {
          let qty = 0;
          costingTableData.CostingWood.forEach(wood => {
            if (
              wood.woodmaterial == costingTableData.CostingProcess[index].Processon &&
              wood.Unit == value
            ) {
              qty = qty + Number(wood.CFT);
            }
          });
          handleChange('CostingProcess', qty, 'size', index);
          const result = qty * costingTableData.CostingProcess[index].prcsrate;
          handleChange('CostingProcess', result, 'prcsamt', index);
        } else {
          if (costingTableData.CostingProcess[index]) {
            const sizeValue = highestValue.toFixed(2);
            handleChange('CostingProcess', sizeValue, 'size', index);
            // For other ProcessTyp values, only update prcsamt
            costingTableData.CostingProcess[index].prcsamt =
              costingTableData.CostingProcess[index].prcsrate;
          }
        }
        setReload(prev => !prev);
      });
      // }
    }
  }, [costingTableData.CostingProcess, changeCount]);
  const columns1: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Wood / Marble Material',
      key: 'woodmaterial',
      fixed: false,
      renderCell: (_, index) => {
        const woodMaterialData = state?.Material?.filter(
          item => item.Type === 'wmaterial' || item.Type === 'mrmaterial'
        );
        return (
          <SelectPicker
            cleanable={false}
            disabled={!productData.isEdit}
            data={woodMaterialData}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingWood[index]?.woodmaterial}
            onChange={value => {
              // Update woodmaterial field
              handleChange('CostingWood', value, 'woodmaterial', index);

              // Find the selected material's rate
              const matchedMaterial = materialData.find(
                mat =>
                  mat.attributes.MaterialName === value &&
                  (mat.attributes.Type === 'wmaterial' || mat.attributes.Type === 'mrmaterial')
              );

              // Update woodrate dynamically
              handleChange(
                'CostingWood',
                matchedMaterial?.attributes?.Cost || 0,
                'woodrate',
                index
              );
              handleChange('CostingWood', matchedMaterial?.attributes?.uom || 0, 'Unit', index);
              handleChange('CostingWood', matchedMaterial?.attributes?.Type || 0, 'Type', index);

              // Recalculate woodamount if CFT exists
              const cft = costingTableData.CostingWood[index]?.CFT || 0;
              const newWoodAmount = cft * (matchedMaterial?.attributes?.Cost || 0);
              handleChange('CostingWood', +newWoodAmount.toFixed(2), 'woodamount', index);

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Components',
      key: 'components',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={categorydata}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingWood[index]?.component}
            onChange={value => handleChange('CostingWood', value, 'component', index)}
          />
        );
      }
    },
    {
      label: 'Remark',
      key: 'remark',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <Input
            // readOnly
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingWood[index]?.remark}
            onChange={value => handleChange('CostingWood', value, 'remark', index)}
          />
        );
      }
    },
    {
      label: 'Final Size',
      key: 'finalSize',
      fixed: false,
      subColumns: [
        {
          label: 'L',
          key: 'L',
          renderCell: (rowData, index) => {
            return (
              <CustomInput
                step={null}
                placeholder="0.00"
                value={costingTableData.CostingWood[index]?.F_L || 0}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_L', index);
                  if (rowData.Unit == 'cft') {
                    const temprowdata = rowData;
                    temprowdata.F_L = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.F_L = value;
                    temprowdata.R_L = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.F_L = value;
                    temprowdata.R_L = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                  const { F_W, F_T } = costingTableData.CostingWood[index];
                  const rawUnit = costingTableData.CostingWood[index]?.R_Unit;
                  const unit = costingTableData.CostingWood[index]?.F_Unit;

                  // Calculate raw sizes
                  let updatedR_L = convertUnit(value, unit, rawUnit);
                  let updatedR_W = convertUnit(F_W, unit, rawUnit);
                  let updatedR_T = convertUnit(F_T, unit, rawUnit);

                  updatedR_L = Math.ceil((parseFloat(updatedR_L) + 4) / 6) * 6;
                  updatedR_W = Number(updatedR_W) + (Number(updatedR_W) * 25) / 100;
                  if (parseFloat('.' + (updatedR_T + '').split('.')[1]) < 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 0.5;
                  } else if (parseFloat('.' + (updatedR_T + '').split('.')[1]) > 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 1;
                  }

                  handleChange('CostingWood', updatedR_L, 'R_L', index);
                  handleChange('CostingWood', updatedR_W, 'R_W', index);
                  handleChange('CostingWood', updatedR_T, 'R_T', index);

                  const updatedCBM = cbmFunction(
                    { R_L: updatedR_L, R_W: updatedR_W, R_T: updatedR_T, R_Unit: rawUnit },
                    costingTableData.CostingWood[index]?.PCS
                  );
                  UpdateCBM(index, updatedCBM);
                }}
              />
            );
          }
        },
        {
          label: 'W',
          key: 'W',
          renderCell: (rowData, index) => {
            return (
              <CustomInput
                step={null}
                placeholder="0.00"
                value={costingTableData.CostingWood[index]?.F_W || 0}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_W', index);
                  if (rowData.Unit == 'cft') {
                    // Convert Final Size W
                    const temprowdata = rowData;
                    temprowdata.F_W = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.F_W = value;
                    temprowdata.R_W = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.F_W = value;
                    temprowdata.R_W = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                  const { F_L, F_T } = costingTableData.CostingWood[index];
                  const rawUnit = costingTableData.CostingWood[index]?.R_Unit;
                  const unit = costingTableData.CostingWood[index]?.F_Unit;

                  let updatedR_L = convertUnit(F_L, unit, rawUnit);
                  let updatedR_W = convertUnit(value, unit, rawUnit);
                  let updatedR_T = convertUnit(F_T, unit, rawUnit);

                  updatedR_L = Math.ceil((parseFloat(updatedR_L) + 4) / 6) * 6;
                  updatedR_W = Number(updatedR_W) + (Number(updatedR_W) * 25) / 100;
                  if (parseFloat('.' + (updatedR_T + '').split('.')[1]) < 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 0.5;
                  } else if (parseFloat('.' + (updatedR_T + '').split('.')[1]) > 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 1;
                  }

                  handleChange('CostingWood', updatedR_L, 'R_L', index);
                  handleChange('CostingWood', updatedR_W, 'R_W', index);
                  handleChange('CostingWood', updatedR_T, 'R_T', index);

                  const updatedCBM = cbmFunction(
                    { R_L: updatedR_L, R_W: updatedR_W, R_T: updatedR_T, R_Unit: rawUnit },
                    costingTableData.CostingWood[index]?.PCS
                  );
                  UpdateCBM(index, updatedCBM);
                }}
              />
            );
          }
        },
        {
          label: 'T',
          key: 'T',
          renderCell: (rowData, index) => {
            return (
              <CustomInput
                step={null}
                placeholder="0.00"
                value={costingTableData.CostingWood[index]?.F_T || 0}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_T', index);
                  if (rowData.Unit == 'cft') {
                    const temprowdata = rowData;
                    temprowdata.F_T = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.F_T = value;
                    temprowdata.R_T = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.F_T = value;
                    temprowdata.R_T = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                  const { F_L, F_W } = costingTableData.CostingWood[index];
                  const rawUnit = costingTableData.CostingWood[index]?.R_Unit;
                  const unit = costingTableData.CostingWood[index]?.F_Unit;

                  let updatedR_L = convertUnit(F_L, unit, rawUnit);
                  let updatedR_W = convertUnit(F_W, unit, rawUnit);
                  let updatedR_T = convertUnit(value, unit, rawUnit);

                  updatedR_L = Math.ceil((parseFloat(updatedR_L) + 4) / 6) * 6;
                  updatedR_W = Number(updatedR_W) + (Number(updatedR_W) * 25) / 100;
                  if (parseFloat('.' + (updatedR_T + '').split('.')[1]) < 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 0.5;
                  } else if (parseFloat('.' + (updatedR_T + '').split('.')[1]) > 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 1;
                  }

                  handleChange('CostingWood', updatedR_L, 'R_L', index);
                  handleChange('CostingWood', updatedR_W, 'R_W', index);
                  handleChange('CostingWood', updatedR_T, 'R_T', index);

                  const updatedCBM = cbmFunction(
                    { R_L: updatedR_L, R_W: updatedR_W, R_T: updatedR_T, R_Unit: rawUnit },
                    costingTableData.CostingWood[index]?.PCS
                  );
                  UpdateCBM(index, updatedCBM);
                }}
              />
            );
          }
        },
        {
          label: 'Unit',
          key: 'unit',
          renderCell: (rowData, index) => {
            return (
              <SelectPicker
                data={unitData}
                cleanable={false}
                disabled={!productData.isEdit}
                size="xs"
                searchable={false}
                style={{ width: '100%' }}
                value={costingTableData.CostingWood[index]?.F_Unit}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_Unit', index);
                  // Convert Final Size to Raw Size when changing unit
                  const { F_L, F_W, F_T } = costingTableData.CostingWood[index];
                  const rawUnit = costingTableData.CostingWood[index]?.R_Unit;

                  let updatedR_L = convertUnit(F_L, value, rawUnit);
                  let updatedR_W = convertUnit(F_W, value, rawUnit);
                  let updatedR_T = convertUnit(F_T, value, rawUnit);
                  updatedR_L = Math.ceil(Math.ceil(parseFloat(updatedR_L) + 4) / 6) * 6;
                  updatedR_W = Number(updatedR_W) + (Number(updatedR_W) * 25) / 100;
                  if (parseFloat('.' + (updatedR_T + '').split('.')[1]) < 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 0.5;
                  } else if (parseFloat('.' + (updatedR_T + '').split('.')[1]) > 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 1;
                  }
                  handleChange('CostingWood', updatedR_L, 'R_L', index);
                  handleChange('CostingWood', updatedR_W, 'R_W', index);
                  handleChange('CostingWood', updatedR_T, 'R_T', index);

                  // Calculate and update CBM
                  const updatedCBM = cbmFunction(
                    {
                      R_L: updatedR_L,
                      R_W: updatedR_W,
                      R_T: updatedR_T,
                      R_Unit: rawUnit
                    },
                    costingTableData.CostingWood[index]?.PCS
                  );
                  UpdateCBM(index, updatedCBM);
                }}
              />
            );
          }
        }
      ]
    },
    {
      label: 'Raw Size',
      key: 'rawSize',
      fixed: false,
      subColumns: [
        {
          label: 'L',
          key: 'L',
          renderCell: (rowData, index) => (
            <CustomInput
              step={null}
              placeholder="0.00"
              value={costingTableData.CostingWood[index]?.R_L || 0}
              onChange={value => {
                handleChange('CostingWood', value, 'R_L', index);
                if (rowData.Unit == 'cft') {
                  const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
                  UpdateCBM(index, CBM);
                } else if (rowData.Unit == 'cbm') {
                  const temprowdata = rowData;
                  temprowdata.R_L = value;
                  handleCustomUpdateCBM(temprowdata, index);
                } else if (rowData.Unit == 'sqft') {
                  const temprowdata = rowData;
                  temprowdata.R_L = value;
                  handleCustomUpdateSQFT(temprowdata, index);
                }
              }}
            />
          )
        },
        {
          label: 'W',
          key: 'W',
          renderCell: (rowData, index) => (
            <CustomInput
              step={null}
              placeholder="0.00"
              value={costingTableData.CostingWood[index]?.R_W || 0}
              onChange={value => {
                if (rowData.Unit == 'cft') {
                  handleChange('CostingWood', value, 'R_W', index);
                  const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
                  UpdateCBM(index, CBM);
                } else if (rowData.Unit == 'cbm') {
                  const temprowdata = rowData;
                  temprowdata.R_W = value;
                  handleCustomUpdateCBM(temprowdata, index);
                } else if (rowData.Unit == 'sqft') {
                  const temprowdata = rowData;
                  temprowdata.R_W = value;
                  handleCustomUpdateSQFT(temprowdata, index);
                }
              }}
            />
          )
        },
        {
          label: 'T',
          key: 'T',
          renderCell: (rowData, index) => (
            <CustomInput
              step={null}
              placeholder="0.00"
              value={costingTableData.CostingWood[index]?.R_T || 0}
              onChange={value => {
                if (rowData.Unit == 'cft') {
                  handleChange('CostingWood', value, 'R_T', index);
                  const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
                  UpdateCBM(index, CBM);
                } else if (rowData.Unit == 'cbm') {
                  const temprowdata = rowData;
                  temprowdata.R_T = value;
                  handleCustomUpdateCBM(temprowdata, index);
                } else if (rowData.Unit == 'sqft') {
                  const temprowdata = rowData;
                  temprowdata.R_T = value;
                  handleCustomUpdateSQFT(temprowdata, index);
                }
              }}
            />
          )
        },
        {
          label: 'Unit',
          key: 'unit',
          renderCell: (rowData, index) => {
            const rawUnit = costingTableData.CostingWood[index]?.R_Unit || 'inch';
            const finalUnit = costingTableData.CostingWood[index]?.F_Unit || 'inch';
            const finalData = costingTableData.CostingWood[index];
            return (
              <SelectPicker
                data={unitData}
                disabled={!productData.isEdit}
                size="xs"
                cleanable={false}
                searchable={false}
                style={{ width: '100%' }}
                value={rawUnit}
                onChange={value => {
                  handleChange('CostingWood', value, 'R_Unit', index);
                  console.log('rowData', rowData);
                  if (rowData.Unit == 'cft') {
                    const temprowdata = rowData;
                    temprowdata.R_Unit = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.R_Unit = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.R_Unit = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                }}
              />
            );
          }
        }
      ]
    },
    {
      label: 'Pcs',
      key: 'pcs',
      fixed: false,
      renderCell: (rowData, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingWood[index]?.PCS || 0}
            onChange={value => {
              handleChange('CostingWood', value, 'PCS', index);
              if (rowData.Unit == 'cft') {
                const temprowdata = rowData;
                temprowdata.PCS = value;
                handleCustomUpdateCFT(temprowdata, index);
              } else if (rowData.Unit == 'cbm') {
                const temprowdata = rowData;
                temprowdata.PCS = value;
                handleCustomUpdateCBM(temprowdata, index);
              } else if (rowData.Unit == 'sqft') {
                const temprowdata = rowData;
                temprowdata.PCS = value;
                handleCustomUpdateSQFT(temprowdata, index);
              }
            }}
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'CFT unit',
      fixed: false,
      renderCell: (rowData, index) => {
        return (
          <SelectPicker
            cleanable={false}
            size="xs"
            placeholder={costingTableData.CostingWood[index]?.Unit}
            style={{ width: '60%' }}
            searchable={false}
            value={costingTableData.CostingWood[index]?.Unit || 0}
            data={
              costingTableData.CostingWood[index]?.Type != 'wmaterial'
                ? marbelUnitData
                : woodUnitData
            }
            onChange={value => {
              handleChange('CostingWood', value, 'Unit', index);
              if (value == 'cft') {
                handleCustomUpdateCFT(rowData, index);
              } else if (value == 'cbm') {
                handleCustomUpdateCBM(rowData, index);
              } else if (value == 'sqft') {
                handleCustomUpdateSQFT(rowData, index);
              }
            }}
          />
        );
      }
    },
    {
      label: 'QTY',
      key: 'CFT QTY',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={(costingTableData.CostingWood[index]?.CFT / 1).toFixed(3)}
            readOnly
            onChange={value => handleChange('CostingWood', value, 'CFT', index)}
          />
        );
      }
    },
    {
      label: 'Rate',
      key: 'rate',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingWood[index]?.woodrate || 0}
            onChange={value => {
              handleChange('CostingWood', value, 'woodrate', index);
              if (costingTableData.CostingWood[index]?.CFT && value) {
                const result = Number(costingTableData.CostingWood[index]?.CFT) * Number(value);
                if (costingTableData.CostingWood[index]) {
                  if (value) {
                    costingTableData.CostingWood[index].woodamount = +result.toFixed(2);
                  }
                }
              } else {
                costingTableData.CostingWood[index].woodamount = 0;
              }
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Amount',
      key: 'amount',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingWood[index]?.woodamount}
            readOnly
            onChange={value => handleChange('CostingWood', value, 'woodamount', index)}
          />
        );
      }
    },
    {
      label: 'Add Material',
      key: 'addMaterial',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                disabled={!productData.isEdit}
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('CostingWood', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];

  const { Height, Length, Width, SizeUnit } = productData;

  const convertedHeight = SizeUnit === 'cm' ? Height / 2.54 : Height;
  const convertedLength = SizeUnit === 'cm' ? Length / 2.54 : Length;
  const convertedWidth = SizeUnit === 'cm' ? Width / 2.54 : Width;

  const highestValue = Math.max(
    parseFloat(convertedHeight),
    parseFloat(convertedLength),
    parseFloat(convertedWidth)
  );

  // useEffect(() => {
  //   if (productData?.ProductionDetail?.length && materialData) {
  //     const updatedCostingProcess = productData.ProductionDetail.map(detail => {
  //       const matchedMaterial = materialData.find(
  //         mat => mat.attributes.MaterialName === detail.MaterialNm
  //       );
  // console.log('state?.Process');
  // console.log(state?.Process);
  //       const processType = matchedMaterial?.attributes?.Type || '';
  //       const processPrice = matchedMaterial?.attributes?.Cost || 0; // Default to 0 if no cost found
  //       const processmaterial = matchedMaterial?.attributes?.MaterialName || ''; // Default to 0 if no cost found

  //       const matchedProcess = state?.Process.find(p => p.Type === detail.Type);
  //       return {
  //         Process: matchedProcess?.value || '', // Set from ProductionDetail
  //         Processon: processmaterial, // Derived from type
  //         ProcessTyp: '', // Default empty
  //         size: '', // Default size
  //         prcsrate: processPrice, // Derived cost from materialData
  //         prcsamt: 0, // Default amount
  //       };
  //     });

  //     handleChange('CostingProcess', updatedCostingProcess, 'init');
  //     setReload(prev => !prev);
  //   }
  // }, [productData?.ProductionDetail, materialData, state?.Process]);

  useEffect(() => {
    if (state?.Process?.length && productData?.ProductionDetail?.length && materialData?.length) {
      const updatedCostingProcess = state.Process.map((processItem, index) => {
        const selectedProcess = state?.Process?.find(item => item.value === processItem.value);
        const price = selectedProcess?.Price || 0; // Get the price for the selected process

        const matchedMaterials = productData?.ProductionDetail.map(detail =>
          materialData.find(mat => mat.attributes.MaterialName === detail.MaterialNm)

        ).filter(Boolean); // Remove undefined values
        const chiefMaterialTypes = matchedMaterials
          .filter(item => item.attributes.Type === processItem.Type) // Filter only matching types
          .map(item => item.attributes.MaterialName); // Extract MaterialName

        let processType = processItem.uom; // Default Process Type

        // Calculate total wgtqty if processType is 'kg' or 'Pcs'
        let totalWgtQty = costingTableData.CostingMaterial.reduce((sum, item) => {
          return sum + (item.wgtqty || 0);
        }, 0);

        // let size = processType === 'Inch' ? highestValue : 0;
        let size = 0;
        if (processType === 'Inch') {
          size = highestValue || 0
        } else if (processType === 'kg' || processType === 'Pcs') {
          size = totalWgtQty
        }
        // let calculatedAmount = processType === 'Inch' ? highestValue * price : price;
        let calculatedAmount = 0;
        if (processType === 'Inch') {
          calculatedAmount = highestValue * price || price
        } else if (processType === 'kg' || processType === 'Pcs') {
          calculatedAmount = totalWgtQty * price || price
        }
        return {
          Process: processItem.value, // Process from state.Process
          Processon: String(chiefMaterialTypes), // Material Name
          ProcessTyp: processType, // Default to Pcs
          size: size, // Keep previous size value if available
          prcsrate: price, // Get Cost from matchedMaterial
          prcsamt: calculatedAmount.toFixed(2) // Calculated amount
        };
      });

      handleChange('CostingProcess', updatedCostingProcess, 'init');
      setReload(prev => !prev);
    }
  }, [state?.Process, productData?.ProductionDetail, materialData, costingTableData.CostingMaterial]);
  const [prevwooddata, setPrevwooddata] = useState();

  const columns2: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Process',
      key: 'process',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={state?.Process?.map(item => ({
              label: item.label,
              value: item.value
            }))}
            cleanable={false}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingProcess[index]?.Process}
            onChange={value => {
              const selectedProcess = state?.Process?.find(item => item.value === value);
              const price = selectedProcess?.Price || 0; // Get the price for the selected process
              const processType = selectedProcess?.Type || '';

              // Find material that matches the process type
              const matchedMaterial = materialData.find(mat => mat.attributes.Type === processType);
              const processOnValue = matchedMaterial?.attributes?.MaterialName || 'Unknown'; // Material Name

              handleChange('CostingProcess', value, 'Process', index); // Update process value
              handleChange('CostingProcess', processOnValue, 'Processon', index); // Update Processon
              handleChange('CostingProcess', price, 'prcsrate', index); // Update rate

              // Recalculate `prcsamt` based on `ProcessTyp`
              if (costingTableData.CostingProcess[index]?.ProcessTyp === 'Inch') {
                const size = +costingTableData.CostingProcess[index]?.size || 0;
                const result = size * price; // Multiply size by price
                handleChange('CostingProcess', result, 'prcsamt', index);
              } else {
                handleChange('CostingProcess', price, 'prcsamt', index);
              }

              setReload(prev => !prev); // Trigger re-render

              // Reset size and rate fields in FieldData if necessary
              setFieldData(prev => ({
                ...prev,
                size: 0,
                rate: 0
              }));
            }}
          />
        );
      }
    },
    {
      label: 'Process On',
      key: 'Processon',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <Input
            size="xs"
            placeholder="Material"
            value={costingTableData.CostingProcess[index]?.Processon}
            readOnly
            onChange={value => {
              handleChange('CostingProcess', value, 'Processon', index);
            }}
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'prcType',
      fixed: false,
      renderCell: (_, index) => {
        const updateSizeAndAmount = (qty: number) => {
          handleChange('CostingProcess', qty, 'size', index);
          const rate = costingTableData.CostingProcess[index]?.prcsrate || 0;
          const result = qty * rate;
          handleChange('CostingProcess', result, 'prcsamt', index);
        };

        return (
          <>
            <SelectPicker
              data={PCSData}
              disabled={!productData.isEdit}
              size="xs"
              style={{ width: '100%' }}
              searchable={false}
              cleanable={false}
              value={costingTableData.CostingProcess[index]?.ProcessTyp}
              onChange={value => {
                handleChange('CostingProcess', value, 'ProcessTyp', index);

                const processData = costingTableData.CostingProcess[index];

                if (!processData) return;

                if (value === 'Inch') {
                  const sizeValue = highestValue || 0;
                  updateSizeAndAmount(sizeValue);
                } else if (value === 'kg' || value === 'Pcs') {
                  let totalWgtQty = costingTableData.CostingMaterial.reduce((sum, item) => {
                    return sum + (item.wgtqty || 0);
                  }, 0);
                  updateSizeAndAmount(totalWgtQty);
                } else if (value === 'sqft') {
                  let qty = 0;
                  costingTableData.CostingWood.forEach(wood => {
                    if (
                      wood.woodmaterial === processData.Processon &&
                      wood.Unit === value
                    ) {
                      qty += Number(wood.CFT || 0);
                    }
                  });
                  updateSizeAndAmount(qty);
                } else if (value === 'cft') {
                  let qty = 0;
                  costingTableData.CostingWood.forEach(wood => {
                    if (
                      wood.woodmaterial === processData.Processon &&
                      wood.Unit === value
                    ) {
                      qty += Number(wood.CFT || 0);
                    }
                  });
                  updateSizeAndAmount(qty);
                } else {
                  // Fallback for unknown unit types
                  const sizeValue = highestValue || 0;
                  updateSizeAndAmount(sizeValue);
                }

                setReload(prev => !prev);

                // Reset other temp fields
                setFieldData(prev => ({
                  ...prev,
                  size: 0,
                  rate: 0
                }));
              }}
            />
          </>
        );
      }
    },
    {
      label: 'Weight/Qty',
      key: 'size',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingProcess[index]?.size}
            onChange={value => {
              // Update the size
              handleChange('CostingProcess', value, 'size', index);

              // Get the rate
              const rate = costingTableData.CostingProcess[index]?.prcsrate || 0;

              // Calculate amount = size * rate
              const result = +value * +rate;

              // Update the amount
              handleChange('CostingProcess', result, 'prcsamt', index);

              // Optionally, force re-render
              setReload(prev => !prev);
            }}
          />
        );
      }
    },

    {
      label: 'Rate',
      key: 'rate',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingProcess[index]?.prcsrate || 0}
            onChange={value => {
              handleChange('CostingProcess', value, 'prcsrate', index);
              if (costingTableData.CostingProcess[index]?.ProcessTyp == 'Inch') {
                if (costingTableData.CostingProcess[index]) {
                  const result = +costingTableData.CostingProcess[index].size * +value;
                  costingTableData.CostingProcess[index].prcsamt = result;
                  setReload(prev => !prev);
                }
              } else {
                if (costingTableData.CostingProcess[index]) {
                  costingTableData.CostingProcess[index].prcsamt =
                    costingTableData.CostingProcess[index].prcsrate;
                  setReload(prev => !prev);
                }
              }
              setFieldData(prev => ({
                ...prev,
                size: 0,
                rate: 0
              }));
            }}
          />
        );
      }
    },
    {
      label: 'Amount',
      key: 'amount',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            readOnly
            value={(costingTableData.CostingProcess[index]?.prcsamt / 1).toFixed(3)}
            onChange={value => handleChange('CostingProcess', value, 'prcsamt', index)}
          />
        );
      }
    },
    {
      label: 'Add Material',
      key: 'addMaterial',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                disabled={!productData.isEdit}
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('CostingProcess', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];

  const columns3: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Material',
      key: 'material',
      fixed: false,
      renderCell: (_, index) => {
        const woodMaterialData = state?.Material?.filter(item => item.Type === 'amaterial');
        return (
          <SelectPicker
            disabled={!productData.isEdit}
            data={woodMaterialData}
            size="xs"
            cleanable={false}
            style={{ width: '100%' }}
            value={costingTableData.CostingAccessory[index]?.materialname}
            onChange={value => {
              // Update the materialname field
              handleChange('CostingAccessory', value, 'materialname', index);
              const matchedMaterial = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'amaterial'
              );
              // Update the matcost dynamically
              handleChange(
                'CostingAccessory',
                +matchedMaterial?.attributes?.Cost || 0,
                'matcost',
                index
              );
              handleChange(
                'CostingAccessory',
                matchedMaterial?.attributes?.uom || 'kg',
                'uom',
                index
              );
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'uom',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={unitData2}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            searchable={false}
            cleanable={false}
            value={costingTableData.CostingAccessory[index]?.uom}
            onChange={value => {
              handleChange('CostingAccessory', value, 'uom', index);
              // Reset fields as necessary
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Cost',
      key: 'cost',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingAccessory[index]?.matcost || 0}
            onChange={value => {
              handleChange('CostingAccessory', value, 'matcost', index);
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Add Accessories',
      key: 'addAccessories',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                disabled={!productData.isEdit}
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('CostingAccessory', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];
  const columns4: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Material',
      key: 'material',
      fixed: false,
      renderCell: (_, index) => {
        const woodMaterialData = state?.Material?.filter(item => item.Type === 'pmaterial');
        return (
          <SelectPicker
            data={woodMaterialData}
            disabled={!productData.isEdit}
            size="xs"
            cleanable={false}
            style={{ width: '100%' }}
            value={costingTableData.Costingpacking[index]?.packingmaterial}
            onChange={value => {
              // Update the packingmaterial field
              handleChange('Costingpacking', value, 'packingmaterial', index);

              const matchedMaterial = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'pmaterial'
              );

              // Update the packingcost dynamically
              handleChange(
                'Costingpacking',
                matchedMaterial?.attributes?.Cost || 0,
                'packingcost',
                index
              );
              handleChange(
                'Costingpacking',
                matchedMaterial?.attributes?.uom || 'kg',
                'uom',
                index
              );

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'uom',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={unitData2}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            searchable={false}
            cleanable={false}
            value={costingTableData.Costingpacking[index]?.uom}
            onChange={value => {
              handleChange('Costingpacking', value, 'uom', index);
              // Reset fields as necessary
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Cost',
      key: 'cost',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.Costingpacking[index]?.packingtotalcost || 0}
            onChange={value => {
              handleChange('Costingpacking', value, 'packingtotalcost', index);
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Add Packing',
      key: 'addPacking',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                disabled={!productData.isEdit}
                icon={<TrashIcon />}
                size="sm"
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('Costingpacking', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];
  return { columns, columns1, columns2, columns3, columns4 };
}
